export default __webpack_public_path__ + "93c7af026c67841c70fab38118d23815.png";